var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.962 6.001a1.658 1.658 0 11-1.658 1.658 1.658 1.658 0 011.658-1.658zm2.445 16.329a4.438 4.438 0 01-3.922-7.411l-.202-1.354a5.569 5.569 0 108.667 6.348l-.83-1.234a4.449 4.449 0 01-3.713 3.651zm7.31-3.053l-2.837-4.238-.003.002a.826.826 0 00-.818-.376l-3.328.496-.303-2.035 1.737-.259a.58.58 0 10-.171-1.146l-1.737.259-.119-.795A1.618 1.618 0 0012.3 9.823a1.618 1.618 0 00-1.361 1.839l.602 4.042a1.59 1.59 0 001.807 1.339l4.407-.658 2.562 3.828a.84.84 0 001.165.228.84.84 0 00.234-1.164zM24 24.827a.183.183 0 01-.057.124.439.439 0 01-.167.049H8.196A.233.233 0 018 24.851a.193.193 0 01.169-.197l15.578-3.067a.395.395 0 01.169.026.21.21 0 01.084.148z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--wheelchair-ramp-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'WheelchairRampCircleIcon';
export default Icon;